import { useState } from 'react'
import Select from 'react-select';
import Switch from 'react-switch';
import CustomColumn from '../../../../customControl/CustomColumn';
import { ConfirmationModal } from '../../../../customControl/ConfirmationModal';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../../_actions/loader.actions';
import { postUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../../../commonClass/Session';
import { alphaSpace, getDateCombination, isImageValidPng } from '../../../commonClass/CommonValidation';
import { CommonFileURLWithFolder, ImageDelete, ImageUpload } from '../../../../ImageUpload/ImageCommon';
import { getactivitymanagebyid } from '../../ActivitymasterUtility';
import { getActivityManageId } from '../ManageActivityMaster';

const getHoursAndTime = (time) => {
    const date = new Date(time);
    const hours = date.getHours() || 0;
    const minutes = date.getMinutes() || 0;
    return { hours, minutes }
}

const ActivityVariants = ({ activityData, dropdownData, setSelectTab, setActivityInfo, disabled, editDisabled, setEditDisabled }) => {
    const dispatch = useDispatch();
    const [formValue, setFormValue] = useState({
        ...activityData?.activityInfo,
        ...getHoursAndTime(activityData?.activityInfo?.durationTime),
        inclusionIds: typeof activityData?.activityInfo?.inclusionIds === "string" ? activityData?.activityInfo?.inclusionIds.split(",")
            .map(id => Number(id.trim())).filter(id => !isNaN(id)) : activityData?.activityInfo?.inclusionIds,
        durationDayNo: activityData?.activityInfo?.durationDayNo || 0,
        InfoImageList: activityData?.activityInfo?.InfoImageList || []
    });
    const [deleteInfoImageList, setDeleteInfoImageList] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [formErrors, setFormErrors] = useState({})


    const getNumberList = (startWith = 1, end = 15) =>
        Array.from({ length: end - startWith + 1 }, (_, i) => {
            const val = startWith + i;
            return { label: val, value: val };
        });

    const daysList = getNumberList(0, 15);
    const hoursList = getNumberList(0, 23);
    const minuteList = getNumberList(0, 59);

    const handleOnChanges = (name, value) => {
        setEditDisabled(false);
        setFormValue({ ...formValue, [name]: value });
        setFormErrors({})
    }

    const handleisActive = (e) => {
        if (formValue.ActivityInfoId <= 0 || !formValue.ActivityInfoId) {
            handleOnChanges('isActive', e);
        } else {
            setModalShow(true);
        }
    }

    const handleConfirmation = (e) => {
        if (e === true) {
            setModalShow(false);
            handleOnChanges('isActive', !formValue.isActive);
        }
        else {
            setModalShow(false);
        }
    }

    const handleImageUpload = (e) => {
        if (e?.target?.files?.length > 0) {
            setEditDisabled(false);
            const file = e.target.files?.[0];
            const fileName = getDateCombination(file?.name);
            const filePath = `CMS/Activty/${fileName}`;
            const path = `CMS/Activity/`;

            const fileSize = (file?.size / 1024) / 1024;

            const length = file?.type?.split('/')?.length
            const fileType = file?.type?.split('/')?.[length - 1]?.toString()?.toLowerCase();
            setFormErrors({})
            setFormValue((form) => ({
                ...form,
                imageName: fileName,
                imagePath: filePath,
                imageFile: file,
                IsNeedToUpdate: true,
                Path: file ? path : "",
                size: file ? fileSize : 0,
                type: file ? fileType : "",
            }))
        }
    }

    const handleUploadImage = (e) => {
        setFormErrors(null);
        setEditDisabled(false);
        const files = e?.target?.files;
        const onlyPNGFiles = Object.entries(files)?.map((obj) => obj?.pop(0))?.filter((file) => isImageValidPng(file?.name));
        const fileSizeCheck = Object.entries(onlyPNGFiles)?.map((obj) => obj?.pop(0))?.filter((file) => ((file?.size / 1024) / 1024) <= 5);
        if (files?.length !== onlyPNGFiles?.length) {
            let error = {};
            error.ActivityInfoImage = 'Only PNG file type is accepted.'
            setFormErrors(error);
        }
        else if (onlyPNGFiles?.length !== fileSizeCheck?.length) {
            let error = {};
            error.ActivityInfoImage = 'Please upload an image with size less than 5 MB.'
            setFormErrors(error);
        }
        const imageList = fileSizeCheck?.reduce((acc, file) => {
            const filename = getDateCombination(file?.name);
            acc.push({
                ActivityInfoImageId: 0,
                ImageName: filename,
                ImagePath: `CMS/Activity/${filename}`,
                Path: `CMS/Activity/`,
                File: file,
                needToUpload: true,
                uploaded: false,
            });

            return acc;
        }, []);
        setFormValue((prev) => ({ ...prev, InfoImageList: [...prev?.InfoImageList, ...imageList] }));
    }

    const handleDeleteInfoImage = (indexId, ActivityInfoImageId) => {
        setEditDisabled(false);
        setFormErrors(null);
        if (ActivityInfoImageId === 0) {
            setFormValue((prev) => ({ ...prev, InfoImageList: prev?.InfoImageList?.filter((item, index) => index !== indexId) }));
        }
        else {
            setDeleteInfoImageList((prev) => [...prev, { ...formValue?.InfoImageList?.find((item) => item?.ActivityInfoImageId === ActivityInfoImageId) }]);
            setFormValue((prev) => ({ ...prev, InfoImageList: prev?.InfoImageList?.filter((item) => item?.ActivityInfoImageId !== ActivityInfoImageId) }));
        }
    }

    const validation = () => {
        let errorMessage = {}
        let IsError = true

        if (formValue?.durationDayNo <= 0 && formValue?.hours <= 0 && formValue?.minutes <= 0) {
            errorMessage = { ...errorMessage, durationDayNo: "Input is mandatory, cannot leave blank" }
            IsError = false
        }

        if (formValue?.inclusionIds?.length <= 0 || !formValue?.inclusionIds) {
            errorMessage = { ...errorMessage, InclusionIds: "Kindly select Inclusion" }
            IsError = false
        }

        if (formValue?.activityTypeId <= 0 || !formValue?.activityTypeId) {
            errorMessage = { ...errorMessage, Isthisactivityfor: "Kindly select Is this activity for " }
            IsError = false
        }

        // if (formValue.IsNeedToUpdate > 0 && formValue.size > 5) {
        //     errorMessage = { ...errorMessage, imageName: "Please upload an image smaller than 5 MB." }
        //     IsError = false
        // } else if (formValue.IsNeedToUpdate && !isImageValidPng(formValue.imageFile.name)) {
        //     errorMessage = { ...errorMessage, imageName: "Only PNG file type is accepted." }
        //     IsError = false
        // }

        const onlyPNGFiles = Object.entries(formValue?.InfoImageList)?.map((obj) => obj.pop(0))?.filter((file) => isImageValidPng(file?.ImageName));
        const fileSizeCheck = Object.entries(onlyPNGFiles)?.map((obj) => obj?.pop(0))?.filter((file) => ((file?.size / 1024) / 1024) <= 5);
        if (formValue?.InfoImageList?.length < 1) {
            errorMessage = { ...errorMessage, ActivityInfoImage: "Kindly upload at least one image." }
            IsError = false
        }
        else if (formValue?.InfoImageList?.length > 6) {
            errorMessage = { ...errorMessage, ActivityInfoImage: "You can upload a maximum of 6 images only." }
            IsError = false
        }
        else if (formValue?.InfoImageList?.length !== onlyPNGFiles?.length) {
            errorMessage = { ...errorMessage, ActivityInfoImage: "Only PNG file type is accepted." }
            IsError = false
        }
        // else if (onlyPNGFiles?.length !== fileSizeCheck?.length) {
        //     errorMessage = { ...errorMessage, ActivityInfoImage: 'Please upload an image with size less than 5 MB.' }
        //     IsError = false
        // }

        if (formValue?.descriptions?.trim()?.length <= 0 || !formValue?.descriptions?.trim()) {
            errorMessage = { ...errorMessage, descriptions: "Kindly Enter Overview." }
            IsError = false
        }
        else if (formValue?.descriptions?.trim()?.length > 2000) {
            errorMessage = { ...errorMessage, descriptions: "Maximum character limit is 2000." }
            IsError = false
        }
        setFormErrors(errorMessage)
        return IsError
    }

    const saveData = async () => {
        if (validation()) {
            dispatch(loaderActions.start());
            const statusoftoken = await verifytoken();
            if (statusoftoken) {
                const user = GetLocalStorage();
                const payloadData = {
                    ActivityInfoId: 0,
                    ActivityBasicInfoId: getActivityManageId(),
                    DurationDayNo: formValue?.durationDayNo,
                    DurationTime: `2026-01-01T${formValue?.hours === 0 ? '00' : formValue?.hours > 0 && formValue?.hours <= 9 ? '0' + formValue?.hours : formValue?.hours}:${formValue?.minutes === 0 ? '00' : formValue?.minutes > 0 && formValue?.minutes <= 9 ? '0' + formValue?.minutes : formValue?.minutes}:00`,
                    InclusionIds: formValue?.inclusionIds,
                    ActivityTypeId: formValue?.activityTypeId,
                    Descriptions: formValue?.descriptions,
                    IsActive: formValue?.isActive,
                    InfoImageList: formValue?.InfoImageList,
                    UserId: user?.userMasterID
                }

                const uploadedFiles = formValue?.InfoImageList?.filter((item) => item?.needToUpload) || [];

                const upsertactivityinfo = await postUsersData('/master/v1/upsertactivityinfo', payloadData);
                if (upsertactivityinfo?.status) {

                    if (uploadedFiles?.length > 0) {
                        await Promise.allSettled(
                            uploadedFiles?.map(async (ele) => {
                                if (ele?.needToUpload) {
                                    try {
                                        const uploaded = await ImageUpload(ele?.Path, ele?.ImageName, ele?.File);
                                        ele.uploaded = uploaded;
                                    } catch (error) {
                                        console.error(`Error Upload Image: ${error}`)
                                        dispatch(loaderActions.end())
                                    }
                                }
                                return ele;
                            })
                        );
                    }

                    if (deleteInfoImageList?.length > 0) {
                        await Promise.allSettled(
                            deleteInfoImageList?.map(async (ele) => {
                                try {
                                    await ImageDelete(ele?.ImagePath);
                                } catch (error) {
                                    console.error(`Error Delete Image: ${error}`)
                                }
                            })
                        );
                    }

                    const activityInfoId = getActivityManageId() || activityData?.activityInfo.activityBasicInfoId
                    const retrieveData = await getactivitymanagebyid(activityInfoId);
                    setActivityInfo({
                        ...activityData,
                        activityInfo: {
                            ...retrieveData?.activityInfo,
                            activityBasicInfoId: retrieveData?.BasicInformationForm?.ActivityBasicInfoId
                        },
                        activityInfoInclusion: retrieveData?.activityInfoInclusion
                    });
                    dispatch({ type: 'ALERTING', message: upsertactivityinfo?.message });
                    setSelectTab(3);
                }
                else {
                    dispatch({ type: 'ALERTING', message: upsertactivityinfo?.message });
                }
                dispatch(loaderActions.end());
            }
            else {
                ClearLocalStorage();
                dispatch(loaderActions.end());
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
            }
        }
    }

    return (
        <div className="my-5">
            <div className="container-fluid form_border my-2 py-3">
                <div className="row">

                    <CustomColumn colNum={10} labelText='Activity' labelId='VariantsName' isRequired >
                        <input
                            type="text"
                            className='form-control'
                            name="VariantsName"
                            id="VariantsName"
                            value={activityData?.activityInfo?.ActivityName}
                            disabled={true}
                            placeholder='Activity Name'
                        />
                    </CustomColumn>

                    <CustomColumn classlabel="align-content-center" colNum={10} labelText='Duration of Activity Experience' labelId='ExperienceDuration' isRequired>
                        <div className="row g-2">
                            <div className='days col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12'>
                                <div className='text-muted'> Days </div>
                                <Select
                                    className="dropdown select_dropdown"
                                    inputId='Days'
                                    options={daysList}
                                    value={daysList.find((val) => val.value === formValue.durationDayNo)}
                                    onChange={(val) => { handleOnChanges('durationDayNo', val.value) }}
                                    isSearchable
                                    isDisabled={disabled ? true : false}
                                    placeholder='Days'
                                />
                                {/* {formErrors?.durationDayNo && <div className="text-danger text-start fs_14">{formErrors?.durationDayNo}</div>} */}
                            </div>
                            <div className='hours col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12'>
                                <div className='text-muted'> Hours </div>
                                <Select
                                    className="dropdown select_dropdown"
                                    inputId='Hours'
                                    options={hoursList}
                                    value={hoursList.find((val) => val.value === formValue.hours)}
                                    onChange={(val) => { handleOnChanges('hours', val.value) }}
                                    isSearchable
                                    isDisabled={disabled ? true : false}
                                    placeholder='Hours'
                                />
                                {/* {formErrors?.hours && <div className="text-danger text-start fs_14">{formErrors?.hours}</div>} */}
                            </div>
                            <div className='minutes col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12'>
                                <div className='text-muted'> Minutes </div>
                                <Select
                                    className="dropdown select_dropdown"
                                    inputId='Minutes'
                                    options={minuteList}
                                    value={hoursList.find((val) => val.value === formValue.minutes)}
                                    onChange={(val) => { handleOnChanges('minutes', val.value) }}
                                    isSearchable
                                    isDisabled={disabled ? true : false}
                                    placeholder='Minutes'
                                />
                                {/* {formErrors?.minutes && <div className="text-danger text-start fs_14">{formErrors?.minutes}</div>} */}
                            </div>
                        </div>
                        {formErrors?.durationDayNo && <div className="text-danger text-start fs_14">{formErrors?.durationDayNo}</div>}
                    </CustomColumn>
                </div>

                <div className="row">
                    <CustomColumn colNum={10} labelText='Inclusion' labelId='GeneralInclusions' isRequired >
                        <Select
                            className="dropdown select_dropdown"
                            inputId='Inclusions'
                            options={activityData?.activityInfoInclusion}
                            value={activityData?.activityInfoInclusion?.filter((val) => formValue?.inclusionIds?.includes(val.value))}
                            onChange={(val) => {
                                handleOnChanges('inclusionIds', val.map((inclusion) => inclusion.value))
                            }}
                            isMulti
                            isSearchable
                            isDisabled={disabled ? true : false}
                            placeholder='Inclusions'
                        />
                        {formErrors?.InclusionIds && <div className="text-danger text-start fs_14">{formErrors?.InclusionIds}</div>}
                    </CustomColumn>
                </div>

                <div className="row">
                    <CustomColumn colNum={10} labelText='Is this activity for' labelId='ActivityId' isRequired>
                        <Select
                            className="dropdown select_dropdown"
                            inputId='ActivityTypeId'
                            options={dropdownData?.activityTypesOption}
                            value={dropdownData?.activityTypesOption.find((val) => val.value === formValue.activityTypeId)}
                            onChange={(val) => { handleOnChanges('activityTypeId', val.value) }}
                            isSearchable
                            isDisabled={disabled ? true : false}
                        />
                        {formErrors?.Isthisactivityfor && <div className="text-danger text-start fs_14">{formErrors?.Isthisactivityfor}</div>}
                    </CustomColumn>
                </div>

                <div className="row">
                    <CustomColumn colNum={10} labelText='Image Gallery' labelId='BannerImages' isRequired>
                        <div className="input-group">
                            <input
                                type="file"
                                id="BannerImages"
                                multiple
                                onChange={handleUploadImage}
                                className="form-control btn_add"
                                accept=".png"
                                disabled={disabled ? true : false}
                            />
                            <label className="input-group-text" htmlFor="BannerImages">Browse</label>
                        </div>
                        {formErrors?.ActivityInfoImage && <div className="text-danger fs_14"> {formErrors?.ActivityInfoImage} </div>}

                    </CustomColumn>
                </div>

                <div className="row">
                    <CustomColumn colNum={10} labelText='Overview' labelId='overview' isRequired>
                        <textarea
                            className='form-control'
                            style={{ resize: 'none' }}
                            name="descriptions"
                            id="overview"
                            value={formValue?.descriptions}
                            onChange={(e) => { handleOnChanges(e.target.name, alphaSpace(e.target.value)) }}
                            disabled={disabled ? true : false}
                            placeholder='Overview'
                            rows={3}
                        />
                        {formErrors?.descriptions && <div className="text-danger text-start fs_14">{formErrors?.descriptions}</div>}
                    </CustomColumn>

                    <CustomColumn colNum={10} labelText='Activity status' labelId='VariantsStatus'>
                        <Switch
                            onChange={handleisActive}
                            checked={formValue.isActive}
                            defaultChecked
                            className="react-switch"
                            disabled={disabled ? true : false}
                        />

                        <ConfirmationModal
                            show={modalShow}
                            onHide={() => setModalShow(false)}
                            noconfirm={() => handleConfirmation(false)}
                            yesconfirm={() => handleConfirmation(true)}
                        />
                    </CustomColumn>
                </div>

                <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className='imageGridBox' style={{ gridTemplateColumns: `repeat(6, 1fr)` }} >
                        {
                            formValue?.InfoImageList?.map((imgItem, index) => (
                                <div key={`${imgItem?.ImageName}${index}`} className='position-relative'>
                                    <img
                                        src={
                                            imgItem?.needToUpload ?
                                                URL.createObjectURL(imgItem?.File) :
                                                `${CommonFileURLWithFolder}${imgItem?.ImagePath}`
                                        }
                                        loading='lazy'
                                        className="w-100"
                                        alt={imgItem?.ImageName}
                                        width={"200px"}
                                        height={"200px"}
                                        aspect-ratio={3 / 2}
                                    />

                                    {!disabled && <button className='closebtnimg' onClick={() => handleDeleteInfoImage(index, imgItem?.ActivityInfoImageId)} type="button" data-close disabled={disabled} >&times;</button>}
                                </div>
                            ))
                        }
                    </div>
                </div>

                <div className="text-center mt-2">
                    <button
                        type="button"
                        className='btn btn-primary'
                        disabled={editDisabled}
                        onClick={() => { saveData() }}
                    >
                        Save & Proceed
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ActivityVariants
